<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="vessel-tracking">
    <vx-sidebar
      :sidebarItems=" initialRole=='ROLE_SYSADMIN' ? sidebarItems : initialRole == 'ROLE_OBSERVE_EXCISE_TANKER' ? sidebarItemsObserveExciseTanker : sidebarItemsUser"
      title="RTS.EXCISE-ONLINE"
    />
    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <the-navbar
        :navbarColor="navbarColor"
        :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]"
      />

      <div class="router-view" style="margin-top:60px;width: 100%;">
        <transition :name="routerTransition">
          <div
            v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
            class="router-header flex flex-wrap items-center"
            style="margin-top:90px; margin-left:20px"
          >
            <div
              class="content-area__heading"
              :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}"
            >
              <h2 class="mb-1">{{ routeTitle }}</h2>
            </div>
            <vx-breadcrumb v-if="$route.meta.breadcrumb" class="ml-4 md:block hidden" />
          </div>
        </transition>
        <div :class="{'mt-0': navbarType == 'hidden'}" class="router-content">
          <div class="content-area__content">
            <router-view></router-view>
          </div>
        </div>
      </div>
      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import VxSidebar from "@/layouts/components/vesselSidebar/VxSidebar.vue";
import TheNavbar from "../components/VesselTrackingNavbar.vue";
import themeConfig from "@/../themeConfig.js";
import TheFooter from "../components/TheFooter.vue";
import sidebarItems from "@/layouts/components/vesselSidebar/sidebarItems.js";
import sidebarItemsUser from "@/layouts/components/vesselSidebar/sidebarItemsUser.js";
import sidebarItemsObserveExciseTanker from "@/layouts/components/vesselSidebar/sidebarItemsObserveExciseTanker.js";
import VesselHistory from "../../layouts/components/vesselCustomizer/VesselHistory.vue";
import VesselList from "../../layouts/components/vesselCustomizer/VesselList.vue";
import VesselFilter from "../../layouts/components/vesselCustomizer/Vesselfilter.vue";

import VesselBaseStation from "../../layouts/components/vesselCustomizer/VesselBaseStation.vue";
import { mapState } from "vuex";

export default {
  name: "VesselTracking",
  components: {
    VxSidebar,
    TheNavbar,
    VesselHistory,
    VesselList,
    VesselBaseStation,
    VesselFilter,
    TheFooter
  },
  data() {
    return {
      navbarType: themeConfig.navbarType || "floating",
      navbarColor: themeConfig.navbarColor || "#fff",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      sidebarItemsUser: sidebarItemsUser,
      sidebarItemsObserveExciseTanker: sidebarItemsObserveExciseTanker,
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth, // width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      steps: [
        {
          target: "#btnSidebarToggler",
          content: "Toggle Collapse Sidebar."
        },
        {
          target: ".vx-navbar__starred-pages",
          content:
            "Create your own bookmarks. You can also re-arrange them using drag & drop."
        },
        {
          target: ".i18n-locale",
          content: "You can change language from here."
        },
        {
          target: ".navbar-fuzzy-search",
          content: "Try fuzzy search to visit pages in flash."
        },
        {
          target: ".customizer-btn",
          content: "Customize template based your preference",
          params: {
            placement: "left"
          }
        }
      ],
      titleName: "",
      initialRole: ""
    };
  },

  computed: mapState({
    titlePage: state => state.titlePage,
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating"
      };
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static"
      };
    }
  }),
  watch: {
    titlePage(val) {
      this.titleName = val;
    },
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      if (this.navbarColor == "#fff" && val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    }
  },

  created() {
    this.initialRole = localStorage.getItem("userRole");
    // if (
    //   this.initialRole == "ROLE_SYSADMIN" ||
    //   this.initialRole == "ROLE_ADMIN"
    // ) {
    //   this.sidebarItems = sidebarItems;
    // } else if (
    //   this.initialRole == "ROLE_EDITOR" ||
    //   this.initialRole == "ROLE_VIEWER"
    // ) {
    //   this.sidebarItems = sidebarItemsUser;
    // }
    this.setSidebarWidth();
    if (this.navbarColor == "#fff" && this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    }
  }
};
</script>

